// Modelo Dinamico para monitoreo.

//TIPO 0: Solo LABEL
//{valor:"", descripcion:"", tipo:0 ,label:"g. Exposiciones en trabajos anteriores (ver HCU):",label2:"Tipo Detalle"},

//TIPO 1: select con opciones
//{valor:"", descripcion:"", tipo:1 ,label:"a. Datos de filiación:" ,data:["SI","NO"]},

//TIPO 2: Select con opciones y un campo con descripcion
//{valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Discoteca:",data:["SI","NO"],label2:"veces/mes"},

//TIPO 3: Campo para observaciones inputText
//{valor:"", descripcion:"", tipo:3 ,label:"Valor:"},

//TIPO 4: Campo para observaciones textArea
//{valor:"", descripcion:"", tipo:4 ,label:"Valor:"},

export default class MonitoreoNutricionalScoreSdoCs {
    fecha={}
    lista=[
        {
            encabezado:"1. Información personal y laboral",
            datos:[
                {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
                {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
                {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
                {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
                {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
            ]
        },
        {
            encabezado:"2. Score SD",
            datos:[
                {valor:"", descripcion:"", tipo:8 },
            ]
        }
    ]
}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;





// WEBPACK FOOTER //
// ./src/model/MonitoreoNutricionalScoreSd.js